// extracted by mini-css-extract-plugin
export default {"main":"main_main__LwW6O","headerBgArea":"main_headerBgArea__RM9oq","bgItem1":"main_bgItem1__8pjL5"};